<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-01 16:44:16
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-04-29 14:43:01
-->
<template>
  <div class="yplus-button-row" :class="{
     'bg-gray':gray
  }" :style="fixed?'padding-bottom:calc(50px + 2vw)':''">

      <div class="yplus-button-row " :class="{
        'button-fixed':fixed,
        'bg-white':white,
      }">
          <van-button class="van-button-new" :disabled="disabled" :native-type="nativeType" @click="$emit('click')" :color="color" block>{{text}}</van-button>
      </div>
      
  </div>
</template>

<script>
export default {
    props:{
        text:{
            type:String,
            default:''
        },
        fixed:{
            type:Boolean,
            default:false
        },
        color:{
            type:String,
            default:'#00BCD1'
        },
        nativeType:{
            type:String,
            default:''
        },
        disabled:{
           type:Boolean,
            default:false 
        },
        white:{
            type:Boolean,
            default:false
        },
        gray:{
            type:Boolean,
            default:false
        },
    }
}
</script>

<style scoped>
.yplus-button-row{
    height: 13.3vw;
}
.button-fixed{
    width: 92vw;
    left: 4vw;
    position: fixed;
    bottom: 50px;
    /* height: 44px; */
}
.van-button-new{
    height: 13.3vw;
    font-size: 4.2vw;
    border-radius: 1.6vw;
}
.bg-white{
    background-color: white;
    width: 92vw;
    padding: 2vw 4vw 50px 4vw;
    bottom: 0;
    left: 0;
}
.bg-gray{
    background-color: #f6f6f6;
}
</style>


// WEBPACK FOOTER //
// src/components/YButton.vue